/* eslint-disable jsx-a11y/no-static-element-interactions */
import React from 'react';
import clsx from 'clsx';
import Link from 'next/link';

import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import IconButton from '@material-ui/core/IconButton';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import Hidden from '@material-ui/core/Hidden';
import { makeStyles } from '@material-ui/core/styles';

import RightToolbar from '@modules/theme/layout/components/seller/rightToolbar';
import { miniDrawerWidthSeller, drawerWidthSeller } from '@modules/theme/layout/helpers';
import { storeConfigVar } from '@services/graphql/cache';
import { PRIMARY_DARK } from '@theme_color';
import { features } from '@config';

const useStyles = makeStyles((theme) => ({
    swiftOmsLogo: {
        padding: '12px 24px 12px 0px',
        '& img': { height: 36, verticalAlign: 'middle' },
    },
    appBarShiftDesktop: {
        backgroundColor: '#fff',
        position: 'fixed',
        width: '100vw',
        height: 64,
    },
    appBar: {
        backgroundColor: 'white',
        color: PRIMARY_DARK,
        boxShadow: '2px 0px 20px #4D2F821A',
        marginLeft: miniDrawerWidthSeller,
        width: `calc(100% - ${miniDrawerWidthSeller + 1}px)`,
        zIndex: theme.zIndex.drawer + 1,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
        [theme.breakpoints.down('xs')]: {
            marginLeft: 0,
            width: '100%',
        },
    },
    appBarShift: {
        marginLeft: drawerWidthSeller,
        width: `calc(100% - ${drawerWidthSeller + 1}px)`,
        transition: theme.transitions.create(['width', 'margin'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.enteringScreen,
        }),
        boxShadow: '2px 0px 20px #4D2F821A',
        '&.fullWidth': {
            width: '100%',
        },
    },
    togleMenuButton: {
        marginRight: -6,
        width: 24,
        height: 24,
        transform: 'translateX(-24px)',
        [theme.breakpoints.down('xs')]: {
            marginRight: 0,
            transform: 'translate(0px, -2px)',
        },
    },
    togleMenuIcon: {
        fontSize: 27,
        color: PRIMARY_DARK,
        borderRadius: '3px',
        background: '#fff',
        boxShadow: '0px 3px 6px #DDE1EC',
    },
    toolbar: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
    },
    swiftOmsLogoDesktop: {
        cursor: 'pointer',
        marginBottom: 0,
        paddingBottom: 10,
        justifyContent: 'center',
        '& img': {
            height: 45,
            marginTop: 10,
        },
    },
}));

const Header = ({
    open, setOpen, notificationRes, storeLogo, refetch, chatAgentCode, setLoadLang, hideSidebar,
}) => {
    const classes = useStyles();
    const storeConfig = storeConfigVar();

    const dataChat = {
        chat: (features.chatSystem.enabled && storeConfig?.swiftoms_vendor_enable_chat) ?? false,
        chatAgentCode,
    };

    const HeaderMobile = () => (
        <AppBar position="fixed" className={clsx(classes.appBar)}>
            <Toolbar>
                <div className={clsx(classes.swiftOmsLogo, open ? 'open' : 'close')}>
                    <img alt="" src={(storeLogo && storeLogo.favicon) || '/assets/img/swiftoms_logo_collapsed.png'} />
                </div>
                {!hideSidebar
                    && (
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            edge="start"
                            onClick={() => setOpen(!open)}
                            className={clsx(classes.togleMenuButton)}
                        >
                            <ChevronRightIcon className={classes.togleMenuIcon} />
                        </IconButton>
                    )}
                <RightToolbar notificationRes={notificationRes} setLoadLang={setLoadLang} refetch={refetch} {...dataChat} />
            </Toolbar>
        </AppBar>
    );

    const HeaderDesktop = () => (
        <AppBar
            position="fixed"
            className={clsx(classes.appBar, {
                [classes.appBarShift]: open,
            }, hideSidebar && 'fullWidth')}
        >
            <Toolbar>
                {hideSidebar
                    ? (
                        <Link href="/seller/order/orderlist">
                            <a>
                                <div className={clsx(classes.toolbar, classes.swiftOmsLogoDesktop, open ? 'open' : 'close')}>
                                    <img
                                        alt=""
                                        src={open ? storeLogo?.logo || '/assets/img/swiftoms_logo_expanded.png'
                                            : storeLogo?.favicon || '/assets/img/swiftoms_logo_collapsed.png'}
                                    />
                                </div>
                            </a>
                        </Link>
                    ) : (
                        <IconButton
                            color="inherit"
                            aria-label="open drawer"
                            edge="start"
                            onClick={() => setOpen(!open)}
                            className={clsx(classes.togleMenuButton)}
                        >
                            {open ? <ChevronLeftIcon className={classes.togleMenuIcon} /> : <ChevronRightIcon className={classes.togleMenuIcon} />}
                        </IconButton>
                    )}
                <RightToolbar notificationRes={notificationRes} setLoadLang={setLoadLang} refetch={refetch} {...dataChat} />
            </Toolbar>
        </AppBar>
    );

    return (
        <>
            <Hidden smUp implementation="css">
                {HeaderMobile()}
            </Hidden>
            <Hidden xsDown implementation="css">
                <div className={classes.appBarShiftDesktop} />
                {HeaderDesktop()}
            </Hidden>
        </>
    );
};

export default Header;
